import { createFileRoute } from "@tanstack/react-router";

import { RtoPage } from "../../../features/shipping/rto-page";

export const Route = createFileRoute("/_app/orders/rto")({ component: RtoPage });
